import React from 'react';
import { CreditCard } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import TooltipTipos from '../tooltips/TooltipTipos';

const GraficoTipos = ({ dadosGraficoTipoPagamento, tiposComContas }) => {
  return (
    <div className="space-y-6">
      <div className="rounded-lg p-4 mb-4 bg-[color:var(--surface-muted)] border border-[color:var(--border)]">
        <h4 className="text-sm font-medium text-[color:var(--text-primary)] mb-2 inline-flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-[color:var(--accent)]" />
          Tipos de Pagamento por Conta Bancária
        </h4>
        <p className="text-xs text-[color:var(--text-muted)]">
          Distribuição de contas por tipo de pagamento: Boleto, Transferência, PIX, Dinheiro e outros
        </p>
      </div>
      
      {/* Legenda para Tipos de Pagamento */}
      <div className="flex flex-wrap gap-3 justify-center mb-4">
        {tiposComContas.map((tipoConfig) => (
          <div key={tipoConfig.dataKey} className="flex items-center gap-2">
            <div 
              className="w-4 h-4 rounded" 
              style={{ backgroundColor: tipoConfig.cor }}
            ></div>
            <span className="text-sm text-[color:var(--text-primary)]">{tipoConfig.nome}</span>
          </div>
        ))}
      </div>
      
      <div className="h-80">
        {dadosGraficoTipoPagamento.length === 0 ? (
          <div className="h-full flex items-center justify-center border border-dashed border-[color:var(--border)] rounded-lg bg-[color:var(--surface-muted)]">
            <p className="text-sm text-[color:var(--text-muted)]">Sem dados de tipos de pagamento para exibir.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dadosGraficoTipoPagamento} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" />
              <XAxis 
                dataKey="nome" 
                angle={-45}
                textAnchor="end"
                height={80}
                fontSize={12}
              />
              <YAxis />
              <Tooltip content={(props) => <TooltipTipos {...props} tiposComContas={tiposComContas} />} />
              {tiposComContas.map((tipoConfig) => (
                <Bar 
                  key={tipoConfig.dataKey} 
                  dataKey={tipoConfig.dataKey} 
                  fill={tipoConfig.cor} 
                  name={tipoConfig.nome} 
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default GraficoTipos;




